<div [tp]="JobStateTooltipComponent" [tpData]="$job()" [tpDelay]="[200, 0]" tpPlacement="top" tpVariation="light">
    @if ($job()?.state; as state) {
        <span [class]="jobStateColor(state)" class="cm-thumbnail">
            @if ($progress() !== null) {
                <svg class="cm-progress-ring" viewBox="0 0 36 36" aria-hidden="true">
                    <circle class="cm-progress-ring-track" cx="18" cy="18" r="16" pathLength="100"></circle>
                    <circle
                        class="cm-progress-ring-value"
                        cx="18"
                        cy="18"
                        r="16"
                        pathLength="100"
                        [style.stroke-dasharray]="$progress()! + ' ' + (100 - $progress()!)"
                    ></circle>
                </svg>
            }
            <i class="cm-job-thumbnail-icon" [class]="jobStateIconClass($job())"></i>
        </span>
    } @else {
        <i class="fa-thin fa-question-circle" [style.color]="'#d0d0d0'"></i>
    }
</div>
